// GlitchTip/Sentry Error Tracking Initialization
// Loads for both desk (logged-in) and web (anonymous) users

(function () {
	"use strict";

	// Get config from boot session (logged-in) or window (anonymous/template-injected)
	function getConfig() {
		// Check boot session first (logged-in users on desk)
		if (typeof frappe !== "undefined" && frappe.boot && frappe.boot.glitchtip) {
			return frappe.boot.glitchtip;
		}
		// Check window for template-injected config (anonymous users)
		if (window.GLITCHTIP_CONFIG) {
			return window.GLITCHTIP_CONFIG;
		}
		return null;
	}

	function initGlitchTip() {
		var config = getConfig();
		if (!config || !config.dsn) {
			return;
		}

		// Load Sentry SDK dynamically
		var script = document.createElement("script");
		script.src = "https://browser.sentry-cdn.com/7.100.0/bundle.min.js";
		script.crossOrigin = "anonymous";
		script.onload = function () {
			if (typeof Sentry === "undefined") {
				console.warn("Sentry SDK failed to load");
				return;
			}

			Sentry.init({
				dsn: config.dsn,
				environment: config.environment || "unknown",

				beforeSend: function (event) {
					// Filter out browser extension errors
					if (event.exception && event.exception.values) {
						var msg = event.exception.values[0].value || "";
						if (
							msg.indexOf("chrome-extension://") > -1 ||
							msg.indexOf("moz-extension://") > -1
						) {
							return null;
						}
					}
					return event;
				},

				initialScope: {
					tags: {
						site: window.location.hostname,
					},
					user:
						typeof frappe !== "undefined" &&
						frappe.session &&
						frappe.session.user
							? { username: frappe.session.user }
							: undefined,
				},
			});
		};

		script.onerror = function () {
			console.warn("Failed to load Sentry SDK from CDN");
		};

		document.head.appendChild(script);
	}

	// Initialize when DOM is ready
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initGlitchTip);
	} else {
		initGlitchTip();
	}
})();
